import { render, staticRenderFns } from "./SummaryAgencies.vue?vue&type=template&id=3b256c7b&lang=pug"
import script from "./SummaryAgencies.vue?vue&type=script&lang=js"
export * from "./SummaryAgencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports